





















import Vue, { PropOptions } from 'vue';
import type { QuoteCardType } from '@/components/storyblok/QuoteCard.vue';
import type { PaddingOptions } from '@/components/SectionContainer.vue';

export type Quotes = Blok & {
  title: string;
  subTitle: string;
  quotes: QuoteCardType[];
  paddingTop?: PaddingOptions;
  paddingBottom?: PaddingOptions;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<Quotes>,
  },
});
